module.exports = __webpack_public_path__ + "media/images/logo__fireballsgc-fa10115d312c7ee20bac7a173190eff4.png";